import {initialState, IVideoSettingsState} from './reducer';

export interface IVideoSettings {
  audioOutputDeviceId: string;
  audioInputDeviceId: string;
  videoInputDeviceId: string;
  videoQualityId: string;
}

const VIDEO_SETTINGS_STORAGE_KEY: string = 'video-settings';

const get = (): IVideoSettingsState => {
  const state = localStorage.getItem(VIDEO_SETTINGS_STORAGE_KEY);

  return state === null
    ? undefined
    : {...initialState, ...JSON.parse(state)};
};

const save = (settings: IVideoSettings): void => {
  localStorage.setItem(VIDEO_SETTINGS_STORAGE_KEY, JSON.stringify(settings));
};

export const VideoSettingsLS = {get, save};
